import { Category } from 'types/categories';
import { Checkroom, TShirt, Premium, Gem, Favorite, Bow } from '@wix/wix-ui-icons-common';

export enum CategoryKey {
  BestSellers = 'BEST_SELLERS',
  MensClothing = 'MENS_CLOTHING',
  WomensClothing = 'WOMENS_CLOTHING',
  KidsClothing = 'KIDS_CLOTHING',
  Hats = 'HATS',
  Accessories = 'ACCESSORIES',
}

export const categoryByKey: Record<CategoryKey, Category> = {
  [CategoryKey.BestSellers]: {
    id: 'dca2d586-0d65-4884-8cf8-66fe3112f06c',
    icon: Favorite,
  },
  [CategoryKey.MensClothing]: {
    id: 'cf8abf69-a85b-46ad-9b9f-ddcab4db9474',
    icon: TShirt,
  },
  [CategoryKey.WomensClothing]: {
    id: 'e605a173-20c0-41fe-89ea-31c30965dad2',
    icon: Checkroom,
  },
  [CategoryKey.KidsClothing]: {
    id: '51121e6d-fe55-4b82-a34b-27fa02a11c78',
    icon: Bow,
  },
  [CategoryKey.Hats]: {
    id: 'e09fd0af-90ae-48fd-a38c-2cdebab98017',
    icon: Premium,
  },
  [CategoryKey.Accessories]: {
    id: '72d3e657-c29b-413e-85e3-60b761a9e739',
    icon: Gem,
  },
};
